<template>
  <div id="activity-log-wrapper">
    <fieldset>
      <legend>Activity Task and Note Log</legend>
      <b-table
        striped
        hover
        show-empty
        id="activity-log-items"
        class="activity-log-items"
        :fields="fields"
        :items="logEntries"
        ref="table"
      >
        <template #empty="scope">
          <div class="chemtracker-empty-text">
            No log items have been created yet.
          </div>
        </template>
        <template #cell(action)="row">
          <b-link @click.prevent="removeLogEntry(row.item.id)"> Remove </b-link>
        </template>
        <template #cell(field_incident_invest_activity)="row">
          <div v-html="row.item.field_incident_invest_activity"></div>
        </template>
      </b-table>
    </fieldset>
    <b-button @click="showDialog"> Log Note or Task </b-button>
    <b-modal
      id="add-log-activity-item"
      centered
      scrollable
      title="Log Note or Task"
      size="md"
      hide-footer
    >
      <div class="md-modal-body-padded">
        <add-metadata-entity
          association-bundle="incident_investigation"
          :association-uuid="uuid"
          metadata-type="incident_investigation_activity"
          @submit-form-data="handleAddAction($event)"
        />
      </div>
    </b-modal>
    <b-modal
      size="md"
      scrollable
      id="remove-log-item"
      ok-title="Confirm"
      centered
      @ok="handleConfirmArchiveTaskNote"
      title="Please confirm that you wish to remove this task/note."
    >
      <div v-if="currentTaskNote" class="md-modal-body-padded">
        {{ currentTaskNote.field_incident_invest_activity }}
      </div>
    </b-modal>
  </div>
</template>

<script>
import Jsona from "jsona";
import jsonapiClient from "../../lib/jsonapi_client";
import AddMetadataEntity from "../metadata_entities/AddMetadataEntity.vue";
import raftGenericHelper from "../../lib/raft_generic_helper";
import raftRestClient from "../../lib/raft_rest_client";

const dataFormatter = new Jsona();

export default {
  name: "ActivityLogListing",
  data() {
    return {
      logEntries: [],
      fields: [
        { key: "field_incident_invest_activity", label: "Task/Note" },
        {
          key: "field_prof_display_name",
          label: "Logged By",
          formatter: (value, key, item) => this.formatDisplayName(item),
        },
        { key: "created", label: "Date Logged" },
        { key: "action", label: "" },
      ],
      currentTaskNote: null,
    };
  },
  props: {
    uuid: { type: String, required: true },
  },
  components: {
    AddMetadataEntity,
  },
  methods: {
    showDialog: function () {
      this.$bvModal.show("add-log-activity-item");
    },
    hideDialog: function () {
      this.$bvModal.hide("add-log-activity-item");
    },
    handleAddAction: function () {
      this.hideDialog();
      this.fetchActivityLogView();
    },
    setPageTitle: function () {
      jsonapiClient.getJSONapi(
        "node/incident_investigation/" + this.uuid,
        {
          "fields[node--incident_investigation]": "title",
        },
        (response) => {
          raftGenericHelper.setPageTitle(
            "Activity Log for Incident " + response.data.attributes.title,
            true,
          );
        },
        this.errorEmit,
        this,
      );
    },
    fetchActivityLogView: function () {
      raftRestClient.getRest(
        "/incident-management/incident-investigation-activity-logs/" +
          this.uuid,
        {},
        (response) => {
          this.logEntries = response;
        },
        (error) => {
          console.error(error);
        },
        this,
      );
    },
    removeLogEntry: function (uuid) {
      this.currentTaskNote = this.logEntries.find((item) => item.id === uuid);
      this.$bvModal.show("remove-log-item");
    },
    handleConfirmArchiveTaskNote: function () {
      const data = {
        type: "raft_metadata--incident_investigation_activity",
        id: this.currentTaskNote.id,
        attributes: {
          operative_status: 0,
        },
      };
      jsonapiClient.patchJSONapi(
        "raft_metadata/incident_investigation_activity/" +
          this.currentTaskNote.id,
        data,
        () => {
          this.fetchActivityLogView();
        },
        (error) => {
          console.error(error);
        },
        this,
      );
    },
    formatDisplayName: function (item) {
      if (Number.parseInt(item.uid, 10) === 1) {
        return "Admin";
      }
      return item.field_prof_display_name;
    },
  },
  created() {
    this.setPageTitle();
    this.fetchActivityLogView();
  },
};
</script>

<style scoped>
.md-modal-body-padded {
  padding: 2px 6px 6px 6px;
}
</style>
